var _rect, _rect2, _rect3, _path, _path2, _ellipse, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStateSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 62,
    fill: "none",
    viewBox: "0 0 107 62",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.7273,
    y: 57.233,
    width: 97.273,
    height: 3.6532,
    rx: 1.8266,
    fill: "#e3e9f0",
    opacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.879,
    y: 11.755,
    width: 80.209,
    height: 48.336,
    rx: 1.75,
    fill: "#f5f8fa",
    stroke: "#b3becd",
    strokeDasharray: "3.18 1.59",
    strokeWidth: 1.5909
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.879,
    y: 11.755,
    width: 54.341,
    height: 48.336,
    rx: 1.75,
    fill: "#fff",
    stroke: "#b3becd",
    strokeDasharray: "3.18 1.59",
    strokeWidth: 1.5909
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m42.434 38.98 6.8782-6.8885",
    stroke: "#b3becd",
    strokeLinecap: "round",
    strokeWidth: 1.5909
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m49.312 38.98-6.8783-6.8885",
    stroke: "#b3becd",
    strokeLinecap: "round",
    strokeWidth: 1.5909
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.59,
    cy: 12.576,
    rx: 10.548,
    ry: 10.564,
    fill: "#fff",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.6316 20.02c-1.5632-2.0903-2.4892-4.6863-2.4892-7.4989.0-6.9154 5.5977-12.522 12.503-12.522s12.503 5.6061 12.503 12.522c0 6.9155-5.5976 12.522-12.503 12.522-2.8084.0-5.4005-.9273-7.4877-2.4929l-9.1083 9.122c-.69752.6986-1.8284.6986-2.5259.0-.69752-.6985-.69752-1.8311.0-2.5297l9.1083-9.122zm10.014 1.4451c4.9322.0 8.9305-4.0044 8.9305-8.944.0-4.9396-3.9983-8.9439-8.9305-8.9439s-8.9306 4.0043-8.9306 8.9439c0 4.9396 3.9984 8.944 8.9306 8.944z",
    clipRule: "evenodd",
    fill: "url(#a)",
    fillRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 48.222,
    x2: 16.026,
    y1: 16.098,
    y2: 48.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00baff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007cff",
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateSearch);
export default __webpack_public_path__ + "static/media/empty-state-search.1ed479b0.svg";
export { ForwardRef as ReactComponent };